

/**
 * * 判断是否是开发环境
 *  @param obj 图标
 */
export const cloneDeep = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
